<template>
  <div class="page-test">
    <div class="msg-box" id="msg-scroll">
      <div
        class="card-box"
        v-for="(item, index) in msgList"
        :key="index"
        @click="selectRadar(item)"
      >
        <div>时间：{{ item.time }}</div>
        <div>ip：{{ item.ip }}</div>
        <div>port：{{ item.port }}</div>
        <div>内容：{{ item.msg }}</div>
      </div>
    </div>

    <div class="msg-box send-msg-box">
      <h3 style="text-align: center; margin-bottom: 10px">
        选中ip: {{ select.ip }}
      </h3>
      <div class="send-list" id="send-scroll">
        <div class="card-box" v-for="(item, index) in sendList" :key="index">
          <div>时间：{{ item.time }}</div>
          <div>ip：{{ item.ip }}</div>
          <div>port：{{ item.port }}</div>
          <div>内容：{{ item.msg }}</div>
        </div>
      </div>
      <div class="send-box">
        <el-input v-model="sendMsg"></el-input>
        <el-button
          type="primary"
          :disabled="sendMsg == '' || !select.ip"
          @click="send"
          >发送</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils/utils";

let webSocket;
let wsUrl = "wss://applet.whst.com/wss/sstk-plat/ws/four-g/data";
// let wsUrl = "ws://172.16.12.55:8082/sstk-plat/ws/four-g/data";
let msgScroll;
let sendScroll;

let msgMap = new Map();

export default {
  name: "Test",
  data() {
    return {
      msgList: [],
      sendMsg: "",
      sendList: [],
      select: {},
    };
  },
  created() {},
  mounted() {
    this.webSocketInit();
    msgScroll = document.getElementById("msg-scroll");
    sendScroll = document.getElementById("send-scroll");
  },
  beforeDestroy() {
    if (webSocket) {
      webSocket.close();
    }
  },
  computed: {},
  methods: {
    webSocketInit() {
      // 判断websocket环境
      if ("WebSocket" in window) {
        webSocket = new WebSocket(wsUrl);
      } else if ("MozWebSocket" in window) {
        webSocket = new MozWebSocket(wsUrl);
      } else {
        webSocket = new SockJS(wsUrl);
      }

      // websocket连接
      webSocket.onopen = () => {};

      // websocket接收消息
      webSocket.onmessage = (msg) => {
        let data = JSON.parse(msg.data);

        if (data.length > 0) {
          data.forEach((item) => {
            item.time = utils.formatTime(new Date());
            if (msgMap.has(item.ip + item.port)) {
              this.msgList.forEach((itm, index) => {
                if (itm.ip + itm.port == item.ip + item.port) {
                  this.msgList.splice(index, 1, item);
                }
              });
            } else {
              msgMap.set(item.ip + item.port, item);
              this.msgList.push(item);
            }
          });

          this.$nextTick(() => {
            msgScroll.scrollTop = msgScroll.scrollHeight;
          });
        }
      };

      // websocket错误
      webSocket.onerror = (ev) => {};

      // websocket关闭
      webSocket.onclose = (e) => {
        if (e.code == 1006) {
          this.webSocketInit();
        }
      };
    },

    selectRadar(data) {
      this.select = data;
    },

    send() {
      let data = {
        ip: this.select.ip,
        port: this.select.port,
        msg: this.sendMsg,
      };
      webSocket.send(JSON.stringify(data));
      data.time = utils.formatTime(new Date());
      this.sendList.push(data);

      this.$nextTick(() => {
        sendScroll.scrollTop = sendScroll.scrollHeight;
      });
      this.sendMsg = "";
    },
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-test {
  width: 100%;
  height: 100vh;
  display: flex;

  .msg-box {
    flex: 1;
    height: 100vh;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    transition: 0.3s;

    .card-box {
      width: fit-content;
      background: #7d8e95;
      color: #fbe0c3;
      font-size: 15px;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 5px;
      box-shadow: 2px 2px 5px #7d8e95;
      margin-bottom: 10px;
      cursor: pointer;
      word-break: break-all;
    }
  }
  .send-msg-box {
    border-left: 1px solid #344648;
    display: flex;
    flex-direction: column;

    .send-list {
      flex: 1;
      overflow-y: auto;
    }
    .send-box {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/test.vue